import { Route } from "react-router-dom";
import React from "react";

import { NotFoundNavigation } from "./Navigation";

export const NotFoundRedirectRoutes = (
  /**
   * When using these redirects, ensure that they are last in the list.
   * The `path="*"` catch all route is greedy, so all routes ordered after
   * will be ignored.
   *
   * Additionally, this is intentionally NOT a component because all
   * component children of <Routes> must be a <Route> or <React.Fragment>
   */
  <>
    <Route index element={<NotFoundNavigation />} />
    <Route path="*" element={<NotFoundNavigation />} />
  </>
);
